import { gql } from '@apollo/client';

export const GET_WATER_SUPPLIER_IDS = gql`
  query GetWaterSupplierIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterSuppliers(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["profileId"]
    ) {
      profileId
    }
  }
`;

export const GET_WATER_SUPPLIERS = gql`
  query GetWaterSuppliers(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterSuppliers(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      profileId
      hasUser
      profile {
        id
        name
        phones {
          value
        }
        emails {
          value
        }
        contactAddress {
          street1
          street2
          city
          state
          zip
          zipExt
        }
      }
    }
  }
`;

export type WaterSupplierItem = {
  profileId: string;
  hasUser: boolean;
  profile: {
    id: string;
    name: string;
    phones: {
      value: string;
    };
    emails: {
      value: string;
    };
    contactAddress?: {
      street1: string;
      street2: string;
      city: string;
      state: string;
      zip: string;
      zipExt: string;
    };
  };
};
